"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEncryptedSecret = void 0;
const tslib_1 = require("tslib");
const axios_1 = require("axios");
const constants_1 = require("../../constants");
const helpers_1 = require("../../helpers");
const getEncryptedSecret = options => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
  const {
    sessionKey,
    env = constants_1.default.ENV.PROD
  } = options || {};
  try {
    if (sessionKey === undefined || sessionKey === null) {
      throw new Error('sessionKey is required');
    }
    const API_BASE_URL = (0, helpers_1.getAPIBaseUrls)(env);
    const requestUrl = "".concat(API_BASE_URL, "/v1/chat/encryptedsecret/sessionKey/").concat(sessionKey);
    return axios_1.default.get(requestUrl).then(response => {
      return response.data.encryptedSecret;
    }).catch(err => {
      var _a, _b;
      if ((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) throw new Error((_b = err === null || err === void 0 ? void 0 : err.response) === null || _b === void 0 ? void 0 : _b.data);
      throw new Error(err);
    });
  } catch (err) {
    console.error("[Push SDK] - API  - Error - API ".concat(exports.getEncryptedSecret.name, " -:  "), err);
    throw Error("[Push SDK] - API  - Error - API ".concat(exports.getEncryptedSecret.name, " -: ").concat(err));
  }
});
exports.getEncryptedSecret = getEncryptedSecret;
//# sourceMappingURL=getEncryptedSecret.js.map